{"model":"/product/skull-2a96969c94.glb","poster":"/product/hero-skull-poster-b896d4075c.webp"}